export const properties = {
    RESOURCE: 'ict',
    urlSelector: '/getIdZona',
    urlValores: '/getValoresEspacioProductivo'
}